import { MutationTree } from 'vuex'
import State, { CartItem } from './types'
import { blankCartItem } from './constants'

export const mutations: MutationTree<State> = {
  setActiveCartItem(state, { activeCartItem }: { activeCartItem: CartItem }) {
    state.activeCartItem = activeCartItem
  },

  saveCartItem(state, { cartItem }: { cartItem: CartItem }) {
    state.activeCart.items.push({ ...cartItem })
    state.activeCartItem = blankCartItem
  },

  updateCartItem(state, { cartItem }: { cartItem: CartItem }) {
    const index = state.activeCart.items.findIndex(
      (x) => x.id === state.activeCartItem.id,
    )
    if (index >= 0) {
      state.activeCart.items.splice(index, 1, {
        ...cartItem,
        id: state.activeCartItem.id,
        totalPrice: cartItem.quantity * cartItem.price,
      })
    }
  },

  updateCartItemNumbers(state) {
    let totalItemCount = 1
    for (let index = 0; index < state.activeCart.items.length; index++) {
      const element = state.activeCart.items[index]
      element.itemNumber = totalItemCount * 10
      totalItemCount += 1 + (element.subItems?.length ?? 0)
    }
  },

  deleteCartItem(state, cartItem: CartItem) {
    state.activeCart.items = state.activeCart.items.filter((x) => {
      return x.id !== cartItem.id
    })
  },

  updateCartItemQty(state, cartItem: CartItem) {
    const item = state.activeCart.items.find((x) => x.id === cartItem.id)
    if (cartItem.parent) {
      const subItem = state.activeCart.items.find((x) => x.id === cartItem.parent?.id)?.subItems.find((x) => x.MaterialNumber === cartItem.pcnCatalogNumber)
      if (subItem) {
        const unitPrice = subItem.TotalPrice / subItem.Quantity
        subItem.Quantity = cartItem.quantity
        subItem.TotalPrice = cartItem.quantity * unitPrice
        cartItem.totalPrice = subItem.TotalPrice
      }
      cartItem.parent.price = cartItem.parent.subItems.reduce((acc, subItem) => acc + subItem.TotalPrice, 0)
    } else if (item) {
      item.quantity = cartItem.quantity
      item.totalPrice = cartItem.quantity * item.price
    }
  },

  deleteCartItems(state, cartItems: CartItem[]) {
    state.activeCart.items = state.activeCart.items.filter((item) => {
      return !cartItems.some((cartItem) => cartItem.id === item.id)
    })
  },

  cartItemsCleared(state) {
    state.activeCart.items = []
  },
}
